import React, { useState, useEffect } from "react";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";
import useApi from "../../../hooks/useApi";
import Modal from "../../../utils/customModal";
import { loadingHtml, sucessInfoModal } from "../../../utils/functions";
import { LABELS_ACCOUNT_TYPE } from "../../../shared/AccountTypeSelect";

const RelationDetail = ({ idCompany, idProvider, accountCurrency, goBack }) => {
  const { t } = useTranslation();
  const [data, setData] = useState({});
  const { getApiCAll, cancellCall } = useApi();
  const [modalError, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
    return () => cancellCall();
  }, []);

  const getData = () => {
    setLoading(true);
    getApiCAll(
      `/providers/provider-relation-companies-details/${idCompany}/${idProvider}/${accountCurrency}`
    )
      .then((response) => {
        const data = response.data.data;
        setData(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        let button = {
          formBtn: {
            text: t("general.buttons.close"),
            action: () => {
              setModal({
                show: false,
                content: null,
              });
            },
          },
        };
        let content = sucessInfoModal(
          "Adiciones/Modificaciones",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          button
        );
        setModal({
          show: true,
          content,
        });
      });
  };

  const handlerChange = (event) => {
    const { name, value } = event.target;

    data[name] = value;

    setData({ data });
  };

  return (
    <>
      <div className="provider-bsc-profile client-profile">
        <ReactTitle title={`Detalle de Clientes Relacionados`} />
        <div className="row">
          <div className="col-sm-6">
            <h3>{t("providers.clients.client_title")}</h3>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="relationName">
              {t("providers.clients.client_name")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                type="text"
                id="relationName"
                name="relationName"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.provider?.relation?.name ?? ""}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="relationBusinessId">
              {t("providers.clients.client_identification")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="relationBusinessId"
                name="relationBusinessId"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.provider?.relation?.businessId ?? ""}
              />
            </div>

            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="countryName">
              {t("providers.clients.client_country")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="countryName"
                name="countryName"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.provider?.relation?.country?.name ?? ""}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="providerAccountCurrency">
              {t("providers.clients.currency")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="providerAccountCurrency"
                name="providerAccountCurrency"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data?.customerCurrency ?? ""}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="accounts">
              {t("providers.clients.account_number")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="accounts"
                name="accounts"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data?.customerAccount ?? "No aplica"}
              />
            </div>
          </div>

          <div className="col-sm-6">
            <h3>{t("providers.clients.provider_title")}</h3>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="notificationNameProvider">
              {t("providers.clients.provider_name")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="notificationNameProvider"
                name="notificationNameProvider"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.name ?? "No aplica"}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="businessId">
              {t("providers.clients.provider_identification")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="businessId"
                name="businessId"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.businessId ?? "No aplica"}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="relationCountryName">
              {t("providers.clients.provider_country")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="relationCountryName"
                name="relationCountryName"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.country?.name ?? "No aplica"}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="accountType">
              {t("providers.clients.payment_type")}
              </label>
              <input
                type="text"
                disabled={true}
                id="accountType"
                name="accountType"
                onChange={(event) => handlerChange(event)}
                className="input input--text input-w-aux__input input--active"
                value={
                  LABELS_ACCOUNT_TYPE[
                    data.provider?.accounts[0]?.accountType
                  ] ?? "No aplica"
                }
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="toBillDiscount">
              {t("providers.clients.provider_type")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="toBillDiscount"
                name="toBillDiscount"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={
                  data.provider?.toBillDiscount ? "Descuento" : "Pago Directo"
                }
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="accountNumber">
              {t("providers.clients.account_number")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="accountNumber"
                name="accountNumber"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.provider?.accounts[0]?.accountNumber ?? "No aplica"}
              />
            </div>
            <div className="row-file col-lg-6 col-md-6 col-sm-12">
              <label className="label" htmlFor="toBillDiscount">
              {t("providers.clients.global_approval")}
              </label>
              <input
                type="text"
                className="input input--text input-w-aux__input input--active"
                id="toBillDiscount"
                name="toBillDiscount"
                onChange={(event) => handlerChange(event)}
                disabled={true}
                value={data.provider?.globalApproval ? "Si" : "No"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-actions clearfix">
        <SecondaryButton
          id="btnLimpiar"
          className="btnLimpiar"
          onClick={goBack}
        >
          {t("general.buttons.back")}
        </SecondaryButton>
      </div>
      <Modal show={loading}>{loadingHtml()}</Modal>
      <Modal show={modalError.show}>{modalError.content}</Modal>
    </>
  );
};

export default RelationDetail;
